import { CheckCircle2, Loader2, Globe } from 'lucide-react';

interface DomainPurchaseSuccessProps {
  domain: string;
  status: 'processing' | 'propagating' | 'active' | 'test-mode';
}

export function DomainPurchaseSuccess({ domain, status }: DomainPurchaseSuccessProps) {
  const isTestMode = status === 'test-mode';

  const statusConfig = {
    'processing': {
      icon: <Loader2 className="w-5 h-5 animate-spin" />,
      title: 'Processing registration...',
      description: 'Your domain is being registered. This usually takes a few minutes.',
    },
    'propagating': {
      icon: <Loader2 className="w-5 h-5 animate-spin" />,
      title: 'Setting up your domain...',
      description: 'DNS is propagating. Your domain will be ready within 24-48 hours.',
    },
    'active': {
      icon: <CheckCircle2 className="w-5 h-5" />,
      title: 'Domain connected!',
      description: 'Your domain is ready and will be connected to your website.',
    },
    'test-mode': {
      icon: <Globe className="w-5 h-5" />,
      title: 'Test mode — simulated purchase',
      description: 'No charge was made. In production, this domain would be registered.',
    },
  };

  const config = statusConfig[status];
  const bgColor = isTestMode ? 'bg-amber-50 border-amber-200' : 'bg-green-50 border-green-200';
  const iconColor = isTestMode ? 'text-amber-600' : 'text-green-600';
  const textColor = isTestMode ? 'text-amber-700' : 'text-green-700';
  const subtextColor = isTestMode ? 'text-amber-600' : 'text-green-600';

  return (
    <div className={`${bgColor} border-2 rounded-xl p-5`}>
      <div className="flex items-start gap-4">
        <div className={`w-10 h-10 rounded-full ${isTestMode ? 'bg-amber-100' : 'bg-green-100'} flex items-center justify-center flex-shrink-0 ${iconColor}`}>
          {config.icon}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className={`font-semibold ${textColor}`}>{domain}</span>
            <span className={`text-xs px-2 py-0.5 rounded-full ${isTestMode ? 'bg-amber-200 text-amber-800' : 'bg-green-200 text-green-800'}`}>
              {config.title}
            </span>
          </div>
          <p className={`text-sm mt-1 ${subtextColor}`}>
            {config.description}
          </p>
        </div>
      </div>
    </div>
  );
}
